import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar33Colors = {
  background?: string;
  skin?: string;
  hair?: string;
  accessories?: string;
};

export const Avatar33 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar33Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
    accessories: colors.accessories ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 306" fill="none">
      <G id="avatar33" clipPath="url(#clip0_2286_5317)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="M208.553 139.784c0-48.596-5.233-70.847-45.57-70.847-72.839 0-73.5 9.413-73.5 58.009 0 1.856.072 3.711.2 5.575-.781.08-1.601.271-2.47.581-5.375 1.928-6.267 13.181-1.982 25.143 4.284 11.962 12.113 20.101 17.488 18.173.208-.071.407-.167.606-.27l.677 1.21s-.048 6.499-.263 13.794c-.175 5.941-.47 12.408-.94 16.326-1.051 8.728-4.54 22.235-4.54 22.235s41.684 37.63 71.485 34.827c12.488.04 11.222-12.376 11.222-12.376s-1.625-10.266-.462-16.446c.573-3.066 2.046-7.581 3.376-11.348 18.445-3.879 7.208-21.288 23.821-55.047 2.015-13.555.844-13.507.844-29.555l.008.016Z"
          fill={c.skin}
        />
        <Path
          id="hair"
          d="m124.055 107.314-4.253 3.067c-12.822 9.517-25.811 16.684-31.266 22.331 13.403-1.171 14.821 17.568 14.821 17.568s4.905 2.628 6.96 1.043c2.055-1.584.629-18.197 1.744-24.051 1.107-5.853 5.384-6.642 10.282-11.707 1.537-1.585 4.221-2.198 4.754-3.966l-1.059-3.711s-1.983-.574-1.991-.574h.008Z"
          fill={c.hair}
        />
        <Path
          id="Vector"
          d="M189.208 124.183c-.541-.096-1.378.135-2.628.884-5.686 3.424-6.22 13.562-6.076 16.875.143 3.305 9.421 23.335 4.021 27.914-1.68 1.426-7.112-.247-9.023-.255-11.253-.024-8.418 3.218-6.721 3.441 1.696.231 13.196 1.202 15.362.995 2.166-.215 5.997-1.481 6.347-5.487.351-4.006-5.415-21.678-6.052-25.063-.144-.756 1.425-2.134 2.349-2.891 1.649-2.031 3.313-5.997 9.254-6.005 6.778 0 12.416 5.488 12.416 5.488v-12.241L189.2 124.19l.008-.007Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_2"
          d="M162.664 138.127c-8.712-11.866-26.735-3.576-30.167-.143-.478.478-.574 1.386-.231 2.031.207.39.533.589.86.589.223 0 .438-.096.629-.279.908-.908 3.058-2.23 5.822-3.353 0 .128-.024.255-.024.391a6.34 6.34 0 0 0 12.678 0 6.19 6.19 0 0 0-.493-2.429c3.56.39 6.952 1.887 9.413 5.248.414.565 1.091.565 1.505 0 .414-.566.414-1.489 0-2.055h.008Z"
          fill="#000"
        />
        <Path
          id="Vector_3"
          d="M208.298 138.207c-2.525-3.146-15.785-10.735-22.196.128-.302.517-.302 1.361 0 1.879.303.518.805.518 1.107 0a11.097 11.097 0 0 1 2.135-2.628 5.973 5.973 0 0 0 5.973 5.885c3.273 0 5.973-2.676 5.973-5.973 0-.366-.04-.716-.104-1.059 2.923 1.123 5.304 2.835 6.172 3.91.144.176.303.255.462.255.239 0 .478-.191.629-.541.255-.59.184-1.426-.167-1.864l.016.008Z"
          fill="#000"
        />
        <Path
          id="Vector_4"
          d="M125.329 130.179s11.118-2.118 20.571-2.118c6.706 0 15.1 1.648 18.23 1.983a2.255 2.255 0 0 0 2.007-.86l1.744-2.254a2.237 2.237 0 0 0-1.107-3.504c-4.723-1.474-13.961-4.811-20.308-4.293-9.095.741-15.57 1.091-21.129 11.046h-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_5"
          d="M185.091 128.714c-.104.868.669 1.592 1.537 1.449 3.488-.581 9.748-1.585 13.523-1.473 4.46.127 10.918.868 10.918.868s.837-6.682-.708-7.781c-1.553-1.099-6.977-1.163-11.174-1.163-4.197 0-6.849.908-9.111 1.872-3.528 1.513-4.73 4.149-4.977 6.228h-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_6"
          d="M115.39 194.616c5.32 15.164 21.336 49.488 61.068 66.141a8.976 8.976 0 0 0 1.935.566c3.019-3.656 2.493-8.864 2.493-8.864s-1.625-10.266-.462-16.446c.573-3.066 2.047-7.582 3.377-11.349-40.632 11.628-60.511-20.133-68.411-30.048Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_7"
          d="M180.886 252.45s1.258 12.416-11.221 12.377C139.863 267.63 98.18 230 98.18 230l-53.741 31.203c27.444 27.261 65.249 44.104 106.988 44.104 25.811 0 50.117-6.45 71.405-17.815 7.04-4.149 10.983-7.223 10.983-7.223l-52.921-27.819h-.008Z"
          fill="#000"
        />
        <G id="Group" opacity={0.5}>
          <Path
            id="Vector_8"
            d="M178.545 206.817c-4.484.087-7.112-1.84-7.184-1.88-.382-.215-.525-.717-.318-1.123a.767.767 0 0 1 1.067-.334c.016 0 3.576 1.33 6.387 1.33 2.811 0 5.184-1.577 5.208-1.585a.763.763 0 0 1 1.083.263.853.853 0 0 1-.246 1.138c-.088.064-1.514 2.103-5.997 2.199v-.008Z"
            fill="#2E2017"
          />
        </G>
        <G id="Group_2" opacity={0.5}>
          <Path
            id="Vector_9"
            d="M144.259 181.579c.446-3.225 2.549-4.818 2.597-4.858.247-.239.724-.271 1.075-.056.35.207.43.574.183.821-.008.008-1.656 2.357-1.991 4.372-.334 2.015.844 3.958.852 3.974.175.303.016.629-.374.741-.382.103-.844-.048-1.027-.351-.048-.071-1.768-1.409-1.323-4.635l.008-.008Z"
            fill="#2E2017"
          />
        </G>
        <Path
          id="Vector_10"
          d="M198.526 186.07s-8.673 2.421-18.54 2.692c-10.919.295-23.144-1.513-23.04-.263.191 2.374 17.529 8.394 23.303 7.917 7.573-.622 18.691-9.374 18.277-10.346Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <G id="accessories">
          <Path
            id="inside hat"
            d="M242.097 100.41c-3.958-3.95-15.697-15.092-40.751-7.39 5.678 10.424 6.976 16.971 5.702 34.38 11.882-2.135 50.89-9.589 35.049-26.99Z"
            fill="#121212"
          />
          <Path
            id="accessories_2"
            d="M156.102 41.023s-50.5 11.022-62.884 27.228C73.826 93.625 87.5 133.588 87.5 133.588s29.045-20.699 29.754-21.033c-.056-.151.796-1.418.772-1.601-.86-9.326 25.039-56.058 38.068-69.924l.008-.008Z"
            fill={c.accessories}
          />
          <Path
            id="accessories_3"
            d="M203.846 84.514c-1.258-3.274-11.619-35.01-17.186-37.885-20.348-7.231-30.439-6.124-30.439-6.124-16.573 1.218-29.753 14.223-34.627 20.483-2.174 2.795-3.361 6.244-3.409 9.812-.151 11.117-.461 36.3-.135 40.162 4.508-2.134 15.848-7.207 39.032-16.422 16.374-6.506 34.436-9.421 46.764-10.018v-.008Z"
            fill={c.accessories}
          />
          <Path
            id="accessories_4"
            d="M223.859 86.49c-2.835-1.203-11.587-2.478-23.629-1.84-12.129.636-27.603 3.217-43.738 9.771-22.841 9.278-34.022 14.391-38.466 16.533-2.166 1.044-.454 2.429.143 2.684 0 0 21.185 7.494 42.767-2.58 31.903-10.884 62.839-32.692 82.598-8.856 0 0-8.326-10.903-19.675-15.705v-.008Z"
            fill={c.accessories}
          />
          <Path
            id="accessories_5"
            d="m153.522 40.807 6.005-.15s.183-3.099-3.234-2.621c-3.424.478-2.771 2.763-2.771 2.763v.008Z"
            fill={c.accessories}
          />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5317">
          <Rect width={303.667} height={305.307} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
